import axiosClient from './axiosClient';

export const getLenderTransactions = (params = {}) =>
	axiosClient.get('/api/lender-transactions', { params });

export const getLenderTransactionSummary = () =>
	axiosClient.get('/api/lender-transactions/summary');

export const createLenderTransaction = (payload) =>
	axiosClient.post('/api/lender-transactions', payload);

export const updateLenderTransaction = (id, payload) =>
	axiosClient.put(`/api/lender-transactions/${id}`, payload);

export const deleteLenderTransaction = (id) =>
	axiosClient.delete(`/api/lender-transactions/${id}`);
